export const checkboxTokens = {
  checkbox: {
    root: {
      borderRadius: '{borderRadius.sm}',
      width: '1.25rem', // 20px
      height: '1.25rem', // 20px
      checkedBorderWidth: '2px',
      transitionDuration: '{transition.duration}',
      // No shadow on checkbox per Figma design
      shadow: 'none',
      focusRing: {
        width: '2px',
        style: 'solid',
        color: '{primary.color}'
      }
    },

    colorScheme: {
      light: {
        root: {
          // Unchecked state
          background: '{surface.0}',
          borderColor: '{surface.500}',

          // Hover state - border only (no hover.background token available)
          hoverBorderColor: '{surface.600}',

          // Focus state
          focusBorderColor: '{primary.color}',

          // Checked/Selected state (grouped under 'checked')
          checked: {
            background: '{surface.0}',
            borderColor: '{primary.color}',
            hoverBackground: '{surface.0}',
            hoverBorderColor: '{primary.color}',
            focusBorderColor: '{primary.color}',
            disabledBorderColor: '{surface.400}'
          },

          // Disabled state
          disabledBackground: '{surface.300}',

          // Invalid/Error state
          invalidBorderColor: '{formField.invalidBorderColor}',

          // Filled variant
          filledBackground: '{surface.100}'
        },

        // Icon tokens
        icon: {
          color: '{primary.color}',
          checkedColor: '{primary.color}',
          checkedHoverColor: '{primary.color}',
          disabledColor: '{primary.400}'
        }
      }
    }
  }
};

export type CheckboxTokens = typeof checkboxTokens;
